export default __webpack_public_path__ + "388251e11fed871db9b736d70de25ab1.png";